<template>
    <div>
        <el-form :inline="true">
            <el-form-item>
                <el-button type="primary" @click="dialogVisible = true">新增</el-button>
            </el-form-item>
        </el-form>

        <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                border
                stripe>
            <el-table-column
                    prop="recoveryNum"
                    label="回收数量"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="price"
                    label="价格"
                    width="110">
            </el-table-column>
            <el-table-column
                    prop="icon"
                    label="操作">

                <template slot-scope="scope">
                    <el-button type="text" @click="editHandle(scope.row.id)">编辑</el-button>
                    <el-divider direction="vertical"></el-divider>

                    <template>
                        <el-popconfirm title="这是一段内容确定删除吗？" @confirm="delHandle(scope.row.id)">
                            <el-button type="text" slot="reference">删除</el-button>
                        </el-popconfirm>
                    </template>
                </template>
            </el-table-column>

        </el-table>

        <!--新增对话框-->
        <el-dialog
                title="提示"
                :visible.sync="dialogVisible"
                width="500px"
                :before-close="handleClose">

            <el-form :model="editForm" :rules="editFormRules" ref="editForm">
                <el-form-item label="回收数量" prop="recoveryNum" label-width="140px">
                    <el-input v-model="editForm.recoveryNum" style="width: 300px"></el-input>
                </el-form-item>
                <el-form-item label="价格" prop="price" label-width="140px">
                    <el-input v-model="editForm.price" style="width: 300px"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="resetForm('editForm')">取 消</el-button>
                <el-button type="primary" @click="submitForm('editForm')">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
  export default {
    name: "SetMeal",
    data() {
      return {
        dialogVisible: false,
        editForm: {},
        tableData: [],
        editFormRules: {
          recoveryNum: [
            {required: true, message: '请输入套餐回收数量', trigger: 'blur'}
          ],
          price: [
            {required: true, message: '请输入价格', trigger: 'blur'}
          ]
        },
        roleList: []
      }
    },
    created() {
      this.getSetMealList();
    },
    methods: {
      resetForm(formName) {
        this.$refs[formName].resetFields();
        this.dialogVisible = false
        this.editForm = {}
      },
      handleClose() {
        this.resetForm('editForm')
      },

      getSetMealList() {
        this.$axios.get("/uxm/set-meal/list", {}).then(res => {
          this.tableData = res.data.data
        })
      },
      submitForm(formName) {
        console.log('editForm', this.editForm)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post('/uxm/set-meal/' + (this.editForm.id ? 'edit' : 'add'), this.editForm)
              .then(res => {

                this.$message({
                  showClose: true,
                  message: '恭喜你，操作成功',
                  type: 'success',
                  onClose: () => {
                    this.getSetMealList()
                  }
                });

                this.dialogVisible = false
              })
          } else {
            return false;
          }
        });
      },
      editHandle(id) {
        this.$axios.get('/uxm/set-meal/info/' + id).then(res => {
          this.editForm = res.data.data
          console.log("e", this.editForm)
          this.dialogVisible = true
        })
      },
      delHandle(id) {
        this.$axios.post('/uxm/set-meal/remove/'+ id).then(res => {
          this.$message({
            showClose: true,
            message: '恭喜你，操作成功',
            type: 'success',
            onClose: () => {
              this.getSetMealList()
            }
          });
        })
      }
    }
  }
</script>
